/**
 * Chebyshev-distance ring of tile keys around (cx, cz), clipped to the tile grid
 * `[0, tilesX) × [0, tilesZ)`. Keys are formatted as `"tx,tz"` so callers can use
 * them as `Set<string>` / `Map<string, …>` keys directly.
 *
 * Shared by editor and runtime streamers so their ring traversals stay provably
 * consistent. Callers that want to filter further (e.g. only tiles known to
 * carry a chunk) layer their own predicate on top.
 */
export function chebyshevRing(
  cx: number,
  cz: number,
  radius: number,
  tilesX: number,
  tilesZ: number,
): Set<string> {
  const result = new Set<string>();
  for (let dx = -radius; dx <= radius; dx++) {
    for (let dz = -radius; dz <= radius; dz++) {
      const tx = cx + dx;
      const tz = cz + dz;
      if (tx < 0 || tx >= tilesX || tz < 0 || tz >= tilesZ) continue;
      result.add(`${tx},${tz}`);
    }
  }
  return result;
}

/** Tile coord conversion matching the backend's centred-AABB convention. */
export function tileOf(
  worldX: number,
  worldZ: number,
  worldMinX: number,
  worldMinZ: number,
  tileWorldSize: number,
): { tx: number; tz: number } {
  return {
    tx: Math.floor((worldX - worldMinX) / tileWorldSize),
    tz: Math.floor((worldZ - worldMinZ) / tileWorldSize),
  };
}
